import { AnimatedEmoji } from '../AnimatedEmoji'

const MIN_EMOJIS = 7
const MAX_EMOJIS = 10

const getRandomEmojisCount = () => {
  return Math.floor(Math.random() * (MAX_EMOJIS - MIN_EMOJIS) + MIN_EMOJIS)
}

export const AnimatedEmojis = ({ emoji }: { emoji: string }) => {
  const emojisCount = getRandomEmojisCount()

  return (
    <>
      {Array.from({ length: emojisCount })
        .fill(0)
        .map((e, idx) => (
          <AnimatedEmoji
            key={`emoji-${
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              idx
            }`}
            emoji={emoji}
          />
        ))}
    </>
  )
}
